import React, {createContext, useEffect, useState} from "react"
import {fetchGrouponList, fetchGrouponState} from "../../../api/groupon"
import {useFetch} from "../../../util/useFetch"


const initialState = {
    /**
     * @type FetchType
     */
    grouponListState: {},

    /**
     * @type FetchType
     */
    grouponSettingState: {},

    page: {
        current: 1,
        pageSize: 10
    },
    handlePageChange: () => {

    }


}

export const GroupBuyingContext = createContext(initialState)

export const GroupBuyingProvider = ({children}) => {

    const grouponListState = useFetch(fetchGrouponList)
    const grouponSettingState = useFetch(fetchGrouponState)

    const [page, setPage] = useState(initialState.page)


    const handlePageChange = (current, pageSize) => {
        setPage({
            current,
            pageSize
        })
    }

    useEffect(() => {
        //保留分页数据
        setPage({
            ...(page),
        })
    }, [grouponListState.data])


    const value = {
        grouponListState,
        grouponSettingState,
        page,
        handlePageChange
    }

    return (
        <GroupBuyingContext.Provider value={value}>
            {children}
        </GroupBuyingContext.Provider>
    )
}

export const useGroupBuyingContext = () => {
    const context = React.useContext(GroupBuyingContext)
    if (context === undefined) {
        throw new Error('useGroupBuyingContext must be used within a GroupBuyingProvider')
    }
    return context
}



// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/store/useGroupBuyingContext.js